

function Tasks() {

    return (
        <div>
            <h1>Tasks</h1>
            <section class="tasks">

                <article id="p1" class="task">
                    <h2>P1: Target Rotation</h2>
                    <p>Proposed by Mohammed Hachem Drici (Algeria)</p>
                    <a href="https://training.olinfo.it/task/naoi_target">You can submit here !</a>
                    <ul class="statements">
                        <li><a href="statements/target%20(en).pdf" target="_blank" rel="noopener">English</a></li>
                        <li><a href="statements/target%20(fr).pdf" target="_blank" rel="noopener">Français</a></li>
                        <li><a href="statements/target%20(ar_DZ).pdf" target="_blank" rel="noopener">العربية (DZ)</a></li>
                        <li><a href="statements/target%20(rw).pdf" target="_blank" rel="noopener">Kinyarwanda</a></li>
                        <li><a href="statements/target%20(Tamazight%20(Algeria)).pdf" target="_blank" rel="noopener">Tamazight (DZ)</a></li>
                    </ul>
                </article>


                <article id="p2" class="task">
                    <h2>P2: Dox Taurus Cows</h2>
                    <p>Proposed by Valerio Stancanelli (Italy)</p>
                    <a href="https://training.olinfo.it/task/naoi_farm">You can submit here !</a>
                    <ul class="statements">
                        <li><a href="statements/farm%20(en).pdf" target="_blank" rel="noopener">English</a></li>
                        <li><a href="statements/farm%20(fr).pdf" target="_blank" rel="noopener">Français</a></li>
                        <li><a href="statements/farm%20(ar_DZ).pdf" target="_blank" rel="noopener">العربية (DZ)</a></li>
                        <li><a href="statements/farm%20(rw).pdf" target="_blank" rel="noopener">Kinyarwanda</a></li>
                        <li><a href="statements/farm%20(Tamazight%20(Algeria)).pdf" target="_blank" rel="noopener">Tamazight (DZ)</a></li>
                    </ul>
                </article>


                <article id="p3" class="task">
                    <h2>P3: Tiles</h2>
                    <p>Proposed by Ihnat Zharikhin (Ukraine)</p>
                    <a href="https://training.olinfo.it/task/naoi_tiles">You can submit here !</a>
                    <ul class="statements">
                        <li><a href="statements/tiles%20(en).pdf" target="_blank" rel="noopener">English</a></li>
                        <li><a href="statements/tiles%20(fr).pdf" target="_blank" rel="noopener">Français</a></li>
                        <li><a href="statements/tiles%20(ar_DZ).pdf" target="_blank" rel="noopener">العربية (DZ)</a></li>
                        <li><a href="statements/tiles%20(rw).pdf" target="_blank" rel="noopener">Kinyarwanda</a></li>
                        <li><a href="statements/tiles%20(Tamazight%20(Algeria)).pdf" target="_blank" rel="noopener">Tamazight (DZ)</a></li>
                    </ul>
                </article>


                <article id="p4" class="task">
                    <h2>P4: The Dripping Tap</h2>
                    <p>Proposed by Voicu Mihai-Valeriu (Romania)</p>
                    <a href="https://training.olinfo.it/task/naoi_dripping">You can submit here !</a>
                    <ul class="statements">
                        <li><a href="statements/dripping%20(en).pdf" target="_blank" rel="noopener">English</a></li>
                        <li><a href="statements/dripping%20(fr).pdf" target="_blank" rel="noopener">Français</a></li>
                        <li><a href="statements/dripping%20(ar_DZ).pdf" target="_blank" rel="noopener">العربية (DZ)</a></li>
                        <li><a href="statements/dripping%20(rw).pdf" target="_blank" rel="noopener">Kinyarwanda</a></li>
                        <li><a href="statements/dripping%20(Tamazight%20(Algeria)).pdf" target="_blank" rel="noopener">Tamazight (DZ)</a></li>
                    </ul>
                    <p>
                        <a href="statements/dripping.cpp" download>Solution Template (C++)</a>
                    </p>
                    <p>
                        <a href="statements/grader.cpp" download>Sample Grader (C++)</a>
                    </p>
                </article>
            </section>

        </div>
    );
}

export default Tasks;
